export default __webpack_public_path__ + "static/media/nidhogg_flower.4f8e07bf.png";